import { POPUP_ENRICH_DATA_TRACKING_CODE } from '../../Constants'
import sendTrackingData from '../../Functions/sendTrackingData'
import { setTimeOnSite, validateEmailRegex } from '../../Utils'
import { fetchMiniGameData, validateEmail, submitMinigame } from '../../Services'
import { shouldShowPopup } from '../../Functions/shouldShowPopup'
import { showPopup } from '../../Functions/sendTrackingEvents'
import { generateDefautPage } from './DefaultPage'
import { generateMainContent } from './MainContent'
import { getTrackingId } from './../../Utils'

const showInvalidEmail = (errMesg) => {
  let alertEmail = document.getElementById('alert_email')
  alertEmail.style.display = 'block'
  alertEmail.textContent = errMesg || 'Email không hợp lệ'
}

export const hideInvalidEmail = () => {
  let alertEmail = document.getElementById('alert_email')
  alertEmail.style.display = 'none'
}

export const checkEmail = async (emailInput, node_uuid) => {
  const isEmailValidate = validateEmailRegex(emailInput)

  if (!isEmailValidate) {
    showInvalidEmail()
    return false
  }

  try {
    const resp = await validateEmail(emailInput?.value, node_uuid)
    if (resp.status === 200) {
      hideInvalidEmail()
      return true
    } else {
      showInvalidEmail(resp?.msg?.detail)
      return false
    }
  } catch (error) {
    showInvalidEmail()
    return false
  }
}

export const generateRandomGift = (resp) => {
  if (!resp) return
  if (!shouldShowPopup(resp?.node_uuid)) return
  const checkTimeOnSite = async () => {
    const isOke = await setTimeOnSite(10, resp?.node_uuid)
    // console.log('test: ', isOke)
    if (!isOke) return
    generateDefautPage(resp)
    generateMainContent(resp?.data, resp?.node_uuid)
  }
  checkTimeOnSite()
}
